import React, { useEffect, useState } from "react";
import { useTable, useQueryState } from "hooks";
import { AddNewButton, Page, PendingButton, LoadingMsg } from "components/common";
import { Button, Table } from "reactstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import SettingsClient from "../SettingsClient";
import { ApiClient } from "services";
import ImportModal from "components/ImportModal";
import { contractNotes as importantNotes } from "pages/UserList/modelNames";
import { createPortal } from "react-dom";
import { exportDownload, humanError } from "services/util";
import { formatDate} from "services/util";
import useSelection from './useSelection';


export const List = ({ match, url = "contracts", t, payroll }) => {
  const {
    TableContainer,
    data,
    PayrollTableDataFetch,
    BulkDelet,
    TableSearch,
    ViewingRecords,
    Pagination,
    EditDeleteButtons,
    onDeleteItem,
    filters,
    refreshData,
  } = useTable({
    url,
    match,
  });

  const { allSelected, selected, toggleAllSelected, toggleSelected, updateItems, selected_ids } = useSelection();

  const [history, setHistory] = useQueryState("history");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false)


  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [settingsData, setSettings] = useState();

  const loading = !settingsData || Object.keys(settingsData).length === 0;

  const handleUploadFile = async (selectedFile) => {

    const formData = new FormData();
    setIsLoading(true)
    formData.append('file', selectedFile)

    payroll.post("contracts/bulk_import", formData)
      .then(({ data }) => {
        setIsLoading(false)
        NotificationManager.success(t("File imported successfully"));
        setTimeout(() => {
          setIsModalOpen(false);
          refreshData()
        }, 800);
      })
      .catch((err) => {
        setIsLoading(false);
        const error_message = humanError(err, "Error while importing File", t)
        NotificationManager.error(error_message);
        refreshData()
      });
  }
  const bulk_approve = async () => {
    payroll.put(`contracts/bulk_approve?ids=${selected_ids}`).then((resp) => {
      NotificationManager.success(t("Approved successfully"));
      refreshData()
    }).catch((e) => {
      NotificationManager.error(t("Error while approving"));
    })
  }


  useEffect(()=>{
    updateItems(data.results.filter((i) => (i.status !== 'ended')) || [])
  }, [data.results.length])

  return (
    <Page title="Contracts" className="inv-table">
      {isLoading &&
        createPortal(
          <div className="content">
            <div className="loader"></div>
            {<LoadingMsg />}
          </div>, document.querySelector('#loader-holder')
        )}
      <SettingsClient setSettings={setSettings} />
      <ImportModal
        isOpen={isModalOpen}
        toggle={closeModal}
        title="Contracts"
        importantNotes={importantNotes}
        handleUpload={handleUploadFile}
      />
      {!loading ? 
        <>
          <div className="d-flex justify-content-between align-items-center">
            <TableSearch className="my-0 flex-grow-1 mr-3" />
            <AddNewButton size="sm" resource="Contract" match={match} />
            <Button size="md" color="primary" onClick={openModal}>
              <Trans>Import</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
            </Button>
            <Button size="md" color="primary" onClick={() => { exportDownload(payroll, "contracts/export", 'contracts.xlsx') }}>
              <Trans>Export</Trans> <span className="mx-1" /><i className="fas fa-file-excel" />
            </Button>
            <Button size="md" color="primary" onClick={bulk_approve} disabled={selected_ids===""}>
              <Trans>Approve</Trans>
            </Button>
          </div>
          {/* <ToReview
            url={url}
            match={match}
            t={t}
            client={payroll}
            onApproved={refreshData}
          /> */}
          <hr />
          <div className="d-flex justify-content-between mb-1 mt-2">
            <h4 className="font-weight-light">
              <Trans>{history ? "History" : "Active Contracts"}</Trans>
            </h4>
            <PendingButton
              color="link"
              className="p-0"
              onClick={() => {
                setHistory(history ? undefined : true);
              }}
            >
              View {history ? "Active Contracts" : "History"}
            </PendingButton>
          </div>
          <BulkDelet className="d-none" />
          <TableContainer>
            <Table>
              <thead>
                <tr>
                  <th>
                  <input
                      type="checkbox"
                      onChange={toggleAllSelected}
                      checked={allSelected}
                    />
                  </th>
                  <th sortBy="employee__first_name">
                    <Trans>Employee</Trans>
                  </th>
                  <th sortBy="start_date">
                    <Trans>Start Date</Trans>
                  </th>
                  <th sortBy="end_date">
                    <Trans>End Date</Trans>
                  </th>
                  <th sortBy="status">
                    <Trans>Status</Trans>
                  </th>
                  <th sortBy="salary">
                    <Trans>Salary</Trans>
                  </th>
                  <th sortBy="position">
                    <Trans>Position</Trans>
                  </th>
                  <th><Trans>Actions</Trans></th>
                </tr>
              </thead>
              <tbody>
                {data.results
                  .filter((i) => (history ? (i.status === 'ended') : (i.status !== 'ended')))
                  .map((i) => (
                    <tr key={i.id}>
                      <td>
                      <input
                            type="checkbox"
                            onChange={toggleSelected(i.id)}
                            checked={selected[i.id] || false}
                          />
                      </td>
                      <td>
                        <Link to={`/payroll-new/contracts/${i.id}`}>
                          {i.employee__full_name}
                        </Link>
                      </td>
                      <td>{formatDate(i.start_date)}</td>
                      <td>{formatDate(i.end_date)}</td>
                      <td>{i.status_label}</td>
                      <td>{i.salary}</td>
                      <td>{i.position}</td>
                      <td className="text-end text-nowrap">
                        <EditDeleteButtons
                          url={match.url}
                          id={i.id}
                          onDelete={onDeleteItem}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </TableContainer>
          <PayrollTableDataFetch filters={filters} />
          <div className="d-flex justify-content-between">
            <div className=""><ViewingRecords noCount /></div>
            <div className=""><Pagination /></div>
          </div>
        </>
        :
        <LoadingMsg />}
    </Page>
  );
};


export default List;
